<template>
    <LeaveRequestList :activeTabIndex="1" title="Approved" extraRouteQuery="approved=true" />
</template>

<script>
import LeaveRequestList from "./leave-request-list.vue"
export default { components: { LeaveRequestList } }
</script>
